import moment from "moment";
import ChatService from "../store/services/ChatService";
import { GROUP_CHAT_TYPE } from "../const/const";
async function checkGroupExists(userId) {
    const res = await ChatService.checkChatExits({ user_id: userId });
    return !!(res && res.status && res.data && res.data.status);
}
/**
 * Luôn tìm hoặc tạo chat 1-1 với user rồi mở messenger.
 * Dùng cho deep link /messenger/dm/:user_id.
 */
export async function openOrCreatePrivateChat(store, router, member) {
    if (!member || member.id == null) {
        return { ok: false, message: "Không xác định được người dùng." };
    }
    const displayName = member.fullname || member.name || `User ${member.id}`;
    const formData = new FormData();
    formData.append("name", displayName);
    formData.append("model_type", GROUP_CHAT_TYPE.USER);
    formData.append("model_ids[]", String(member.id));
    const res = await ChatService.createGroupChat(formData);
    if (!res || !res.status || !res.data || res.data.id == null) {
        return {
            ok: false,
            message: (res && res.message) || "Không mở được cuộc trò chuyện.",
        };
    }
    const group = { ...(res.data || {}) };
    delete group.isCreateChat;
    store.commit("chat/updateChatGroupSelected", group);
    store.dispatch("chat/getChatGroups");
    router.push("/messenger/" + group.id);
    return { ok: true, groupId: group.id };
}
/**
 * Mở chat riêng với user — cuộc trò chuyện có sẵn hoặc màn "Tạo tin nhắn riêng".
 * `draftMessage` được điền vào ô nhập, không tự gửi.
 */
export async function openPrivateChatWithDraft(store, router, member, draftMessage = "") {
    if (!member || member.id == null) {
        return { ok: false, message: "Không xác định được người dùng." };
    }
    const draft = draftMessage != null ? String(draftMessage) : "";
    store.commit("chat/setComposeDraftMessage", draft || null);
    const displayName = member.fullname || member.name || "";
    const isChatExists = await checkGroupExists(member.id);
    if (isChatExists) {
        const result = await openOrCreatePrivateChat(store, router, {
            ...member,
            fullname: displayName || member.fullname,
        });
        if (!result.ok) {
            store.commit("chat/setComposeDraftMessage", null);
        }
        return result;
    }
    const selectedChatGroup = {
        avatar: member.avatar_url,
        created_at: moment().format(),
        name: displayName,
        last_message: {},
        updated_at: moment().format(),
        user_id: member.id,
        isCreateChat: true,
        type: GROUP_CHAT_TYPE.USER,
    };
    store.commit("chat/updateChatGroupSelected", selectedChatGroup);
    router.push("/messenger/new" + moment().valueOf());
    return { ok: true };
}
